import { render, staticRenderFns } from "./archivoGeneral.vue?vue&type=template&id=4a57ff0f"
import script from "./archivoGeneral.vue?vue&type=script&lang=js"
export * from "./archivoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports